/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 * 
 * @deprecated
 */
export const Languages = {
    en: {
        /**
         * @deprecated
         */
        system: require("./en/system.js").language,
        /**
         * @deprecated
         */
        component: require("./en/component.js").language,
        /**
         * @deprecated
         */
        rest: require("./en/rest.js").language,
    }
}
